import ActivityRow from './ActivityRow';
import { jsx as _jsx } from "react/jsx-runtime";
export { getActivityIconComponent } from './ActivityRow';
const ActivityBlock = ({
  block,
  message,
  callbacks,
  sectionId
}) => {
  return /*#__PURE__*/_jsx(ActivityRow, {
    activity: block,
    message: message,
    callbacks: callbacks,
    sectionId: sectionId
  });
};
export default ActivityBlock;